<template>
    <div id="shows">
        <div class="data">
            <div class="data-title">
                <div class="title-center "><span @click="goto_back" style="cursor: pointer">智慧照明管理</span></div>
                <div style="width: 100%;">
                    <span id=project
                          style=" left: 20px;position:fixed;;color: white;font-size: 20px;top: 10px">当前项目: {{ current_project.projectName }} |
                         <el-popover
                             placement="top-start"
                             trigger="click"
                             v-model="visible"
                            >
                              <el-select v-model="select_value" placeholder="请选择"    @change="change_currentProject()">
                                <el-option
                                    v-for="(item,index) in project"
                                    :key="index"
                                    :label=(item.projectName)
                                    :value="index"
                                >
                                </el-option>
                              </el-select>
                             <el-link type="primary" slot="reference" >切换</el-link>
                          </el-popover>
                    </span>
                    <span id=localtime style=" right: 20px;position:fixed;;color: white;font-size: 20px;top: 10px">{{
                            localtime
                        }}</span>
                    <!--                     <el-button  @click="goto_back" style="right: 20px;position:fixed;">后台</el-button>-->
                    <!--<span style="right: 20px;color: white;position:fixed;"></span>-->
                </div>

            </div>
            <div class="data-content">
                <div class="con-left fl">
                    <div class="left-top">
                        <div class="info_ boxstyle"  v-loading="getDevice_loading">
                            <div class="title">设备信息</div>
                            <div class="info-main">
                                <ul>
                                    <li><img src="../assets/icon/设备管理.png" alt=""><span>设备总数</span>
                                        <p>{{ device_num }}台</p></li>
                                    <li><img src="../assets/icon/STS开关.png" alt=""><span>漏保开关</span>
                                        <p> 总数:{{ switch_num }} | 在线:{{ switch_online_num }} | 开闸:{{ switch_on_num }}</p></li>
                                    <li><img src="../assets/icon/灯.png" alt=""><span>灯具设备</span>
                                        <p> 总数:{{ light_num }} | 在线:{{ light_online_num }} | 开灯:{{ light_on_num }}</p></li>
                                    <li><img src="../assets/icon/报警.png" alt=""><span>报警消息</span>
                                        <p>{{ tableData.length }}条</p></li>
                                </ul>
                            </div>
                        </div>
                        <div class="top-bottom boxstyle">
                            <div class="title">地区天气环境 | {{current_project.address}}</div>
                            <div class="info-main">
                                <ul>
                                    <li><img src="../assets/home/太阳_sun.png" width="120px" height="120px" alt=""><span>日间天气</span>
                                        <p>{{ first_day_weather.text_day }}</p></li>
                                    <li><img src="../assets/home/月亮_moon.png" width="60px" height="60px" alt=""><span>夜间天气</span>
                                        <p>{{ first_day_weather.text_night }}</p></li>
                                    <li><img src="../assets/home/日出_sunrise.png" width="80px" height="80px"
                                             alt=""><span>日出日落时间</span>
                                        <p>{{ current_project.suntime }}</p></li>
                                    <li style="margin-top: -90px"><img src="../assets/home/wendu.png" width="70px"
                                                                       height="70px"
                                                                       alt=""><span>温度</span>
                                        <p>{{ first_day_weather.low }}~{{
                                                first_day_weather.high
                                            }}度</p></li>
                                    <li style="margin-top: -10px"><img src="../assets/home/降雨量.png" width="40px"
                                                                       height="40px"
                                                                       alt=""><span>降雨率</span>
                                        <p>{{ first_day_weather.precip }}%</p></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <!--                    <div class="left-bottom boxstyle">
                                            <div class="title">车型分类</div>
                                            <div id="echarts_2" class="charts"></div>
                                        </div>-->
                </div>
                <div class="con-center fl">

                    <!--                    <div class="map-num">
                                            <p>实时行驶车辆(辆)</p>
                                            <div class="num">
                                                <span>1</span>
                                                <span>5</span>
                                                <span>4</span>
                                                <span>9</span>
                                                <span>2</span>
                                                <span>6</span>
                                                <span>8</span>
                                            </div>
                                        </div>-->
                    <div class="cen-top boxstyle" id="container">

                    </div>
                    <div class="cen-bottom boxstyle">
                        <div class="title">每日耗能</div>
                        <div id="echarts_3" class="charts"></div>
                    </div>
                </div>
                <div class="con-right fr">
                    <div class="right-top boxstyle">
                        <div class="title">项目耗能</div>
                        <div id="echarts_4" class="charts"></div>
                    </div>
                    <div class="right-center boxstyle">
                        <div class="title">警报消息</div>
                        <div id="echarts_5">
                            <el-table
                                :data="tableData"
                                height="calc(38vh - 80px)"
                                show-overflow-tooltip="true"
                                :header-cell-style="{'text-align':'center','color':'white'}"
                                :row-style="{'text-align':'center','color':'white'}"
                                @row-click="row_handle"
                                style="width: 100%">
                                <el-table-column
                                    align="center"
                                    prop="no"
                                    label="设备ID"
                                    width="120">
                                </el-table-column>

                                <el-table-column
                                    align="left"
                                    show-overflow-tooltip
                                    prop="mes"
                                    label="报警内容"
                                    width="150">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="time"
                                    :formatter="getdate"
                                    label="时间">
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <!--                    style="width: 100%;height: 200px"-->
                    <div class="right-bottom boxstyle">
                        <div class="title">设备概况</div>
                        <div id="echarts_6" class="charts">


                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <!--    <div style="width: 100%;height: 100%">
            <iframe :src="src" class="frame">

            </iframe>
            <span style="text-decoration: none" @click="toback">跳转后台首页</span>|<span style="text-decoration: none" @click="logout">退出</span>
        </div>-->


</template>

<script>
import {useWebSocket} from "../utils/websocket";
import * as echarts from 'echarts'
import AMapLoader from "@amap/amap-jsapi-loader";

export default {
    name: "Home",
    data() {
        return {
            visible:false,
            src: '',
            showSessionId: '',
            category_option: {},
            category_option2: {},
            category_option3: {},
            tableData: [],
            localtime: '',
            total_power: 0,
            project: '',
            current_project: '',
            weather: '',
            first_day_weather:'',
            user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
            select_value:0,

            device_num: 0, //设备总睡
            light_num: 0,//单灯数
            switch_num: 0,//开关数

            online_num: 0, //在线设备数
            light_online_num: 0,//在线单灯数
            switch_online_num: 0,//在线开关数


            light_on_num: 0, //开灯数
            switch_on_num: 0,//开闸数

            getDevice_loading:true,
            marker:'',

        }
    },
    created() {
        this.load()
        this.init();
    },
    mounted() {  // 页面元素渲染之后再触发
        //this.showSessionId = window.location.search
        // this.src = './static/019/index.html'
        this.initAMap();
        //this.echarts_5()
        this.tick()  //右上角时钟
    },
    methods: {
        init(){
            //this.ws = useWebSocket(this.handleMessage);
        },
        handleMessage(evt) {
            if (evt.data) {
               /* this.$notify({
                    title: '提示',
                    message: evt.data,
                });*/
                JSON.parse(evt.data)
                console.log(JSON.parse(evt.data).type)
                let type = (JSON.parse(evt.data)).type
                let no = (JSON.parse(evt.data)).no
                let mess = (JSON.parse(evt.data)).mess
                let text= ''
                if(type=='online'){
                    if(mess=='off'){
                        text = '设备已离线'
                    }else{
                        text = '设备已上线'
                    }
                }
                if(type=='lightValue'){
                    if(mess=='0'){
                        text = '灯光已关闭'
                    }else{
                        text = '灯光已打开'
                    }
                }
                this.$notify({
                    title: '提示',
                    message: "设备:"+no+','+text,
                });

                console.log("获取到的数据为:"+evt.data)
            }
        },

        async load() {
            this.page_loading = true
            this.request.get("/project/findByUser/" + this.user.id, {}).then(res => {
                this.project = res.data
                this.current_project = res.data[0]
                console.log(this.current_project)
                /* this.projectName = res.data[0].projectName
                 this.projectAddress = res.data[0].address*/
                this.weather = JSON.parse((res.data[0].weather + ""))
                //console.log(this.weather.results[0].daily)
                this.first_day_weather = this.weather.results[0].daily[0]
                //console.log(this.first_day_weather)
                this.getDevices(res.data[0].id)

                this.get_SunTime()
                this.getWarn()
                  this.getPowerWeek()
                  this.get_SunTime()
                  this.getAllPower()
                /*   this.page_loading = false*/
            })

        },
        getDevices(pid) {
          this.device_num = 0
            this.light_num = 0
            this.switch_num = 0

            this.online_num = 0,
            this.light_online_num = 0,
            this.switch_online_num = 0,


            this.light_on_num = 0,
            this.switch_on_num = 0,

            this.getDevice_loading = true
            this.request.get("/devices/findByPid", {
                params: {
                    pid: pid,
                    tid: ''
                }
            }).then(res => {
                console.log(res.data)
                this.getDevice_loading = false
                 this.device_num = res.data.device.length
                 //this.online_num = res.data.online
                // this.lighton_num = res.data.lightOn

                let dData = res.data.device
                for (let i = 0; i < dData.length; i++) {
                    if (dData[i].type == 'light' || dData[i].type == 'multi') {
                        this.light_num = this.light_num + 1
                        if (dData[i].online) {
                            this.light_online_num = this.light_online_num + 1
                        }
                        if (dData[i].light_on) {
                            this.light_on_num = this.light_on_num + 1
                        }

                    } else {
                        this.switch_num = this.switch_num + 1
                        if (dData[i].online) {
                            this.switch_online_num = this.switch_online_num + 1
                        }
                        if (dData[i].light_on) {
                            this.switch_on_num = this.switch_on_num + 1
                        }
                    }
                }


                let  option = {
                    tooltip: {
                        trigger: 'item'
                    },

                    series: [
                        {
                            name: '设备概况',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            avoidLabelOverlap: false,

                            itemStyle: {
                                borderRadius: 10,
                                borderColor: '#fff',
                                borderWidth: 2,
                                normal: {
                                    color: function (colors) {
                                        var colorList = [
                                            'rgb(162,244,66)',
                                            'rgb(149,149,150)',
                                            '#e3131a',
                                            '#ef6567',
                                            '#9c1657',
                                            '#75bedc'
                                        ];
                                        return colorList[colors.dataIndex];
                                    }
                                },
                            },
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgb(86,239,247)'

                                }
                            },
                             label: {            //饼图图形上的文本标签
                               normal: {
                                   show: true,
                                   position: 'outer', //标签的位置
                                   textStyle: {
                                       fontWeight: 300,
                                       fontSize: 14,    //文字的字体大小
                                       color: "#fff"
                                   },
                                   formatter: '{b}:{c}'
                               }
                            },
                            data: [
                                { value: 0, name: '开灯数' },
                                { value: 0, name: '灭灯数' },

                            ]
                        }
                    ]
                };


                option.series[0].data[0].value = this.light_on_num
                option.series[0].data[1].value = this.light_num  - this.light_on_num
                var chartDom = document.getElementById('echarts_6');
                var myChart = echarts.init(chartDom);
                // 数据准备完毕之后再set
                myChart.setOption(option);
            })

        },
        initAMap() {
            AMapLoader.load({
                key: '9b16e0ac0b56127f48f850a970ad12ff',
                version: "2.0",
                plugins: ['AMap.ToolBar', 'AMap.Driving', 'AMap.MarkerCluster', 'AMap.MapType', 'AMap.Geolocation'],
                AMapUI: {
                    version: "1.1",
                    plugins: [],
                },
                Loca: {
                    version: "2.0"
                },
            }).then((AMap) => {
                this.map = new AMap.Map("container", {
                    //viewMode: "3D",
                    zoom: this.zoom,
                    zooms: [4, 20],
                    center: this.center,
                });
                var styleName = "amap://styles/macaron";
                this.map.setMapStyle(styleName);
                /* this.map.setFeatures(['road','bg']); // 多个种类要素显示*/
                //this.load()


                /*    this.geolocation = new AMap.Geolocation({
                        enableHighAccuracy: true,//是否使用高精度定位，默认:true
                        timeout: 10000,          //超过10秒后停止定位，默认：5s
                        position:'LB',    //定位按钮的停靠位置
                        offset: [10, 20], //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
                        zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
                    });
                    this.map.addControl(this.geolocation);*/
                /* geolocation.getCurrentPosition(function(status,result){
                     console.log(status)
                     this.$message.error("定位失败")
                     console.log(result)
                     if(status=='complete'){
                         //onComplete(result)
                         this.$message.success("定位成功")
                         this.$message.success("定位成功")
                     }else{
                         this.$message.error("定位失败")

                         //onError(result)
                     }
                 });*/

                /* this.map.on("zoomchange", () => {
                     // console.log(this.map.getZoom())
                     this.scale = this.map.getZoom()
                 })*/
                /* this.map.on("moveend", () => {
                     //console.log(this.map.getCenter().lat)
                     //console.log(this.map.getCenter().lng)
                     this.center = [this.map.getCenter().lng,this.map.getCenter().lat]
                     /!*if(this.centerMarker!=''){
                         this.centerMarker.setPosition(this.center)
                     }*!/
                 })*/

                this.map.on("click", () => {
                    // console.log(this.map.getZoom())
                    //this.scale = this.map.getZoom()
                    //this.show_light_info = false
                    //this.rest_marker()//重置marker状态
                })
            }).catch(e => {
                console.log(e);
            })

        },
        change_currentProject() {
            console.log(this.select_value)

            this.current_project = this.project[this.select_value]
            this.visible = false

            this.weather = JSON.parse((this.project[this.select_value].weather + ""))
            this.first_day_weather = this.weather.results[0].daily[0]

            this.getDevices(this.project[this.select_value].id)
            this.getWarn()
            this.getPowerWeek()
            this.get_SunTime()
            this.getAllPower()

        },
        getWarn() {

            this.getWarn_loading = true
            this.request.get("/project/findWarnById/" +  this.current_project.id, {}).then(res => {
                this.getWarn_loading = false

                let data = JSON.parse(res.data)
                if (data.data == null || data.data.length == 0) {
                    this.tableData = []
                } else {
                    this.tableData = data.data

                }

            })

        },
        goto_back() {
            console.log(1234)
            // this.$router.push({path: '/home'});
            window.location.replace('/home')
        },
        logout() {
            console.log("退出")
            this.$store.commit("logout")
            this.$message.success("退出成功")
        },

        get_SunTime() {

            //this.getSumTime_loading = true
            this.request.get("/sunTime/getToday", {
                params: {
                    address: this.current_project.address
                }
            }).then(res => {
                this.getSumTime_loading = false
                console.log(res)
                this.current_project.suntime = res.data.suntime.split("-")[0] + "-" + res.data.suntime.split("-")[1]

            })
        },
        getPowerWeek() {
            this.category_option = {
                title: {
                    text: '最近15天功耗',
                    left: 'center',
                    textStyle: {
                        color: 'rgba(255,255,255,1)'
                    }
                },

                tooltip: {
                    trigger: 'item'
                },
                xAxis: {
                    type: 'category',
                    lineStyle: {
                        color: '#0f0f0f'
                    },
                    axisLabel: {
                        textStyle: {
                            color: 'rgba(255,255,255,1)',
                            fontSize: '12'
                        },
                        lineStyle: {
                            color: 'rgba(255,255,255,1)',
                        },
                    },
                },

                yAxis: {
                    type: 'value',
                    axisLabel: {
                        textStyle: {
                            color: 'rgba(255,255,255,1)',
                            fontSize: '12'
                        },
                        lineStyle: {
                            color: 'rgba(255,255,255,1)',
                        },
                    },
                },
                series: [
                    {
                        name: '单日功耗',
                        data: [],
                        type: 'bar'
                    }
                ]
            };
            this.request.get("/project/findPowerById/" +  this.current_project.id, {}).then(res => {
                this.category_option.xAxis.data = res.data.date.reverse()
                this.category_option.series[0].data = res.data.power.reverse()
                var chartDom = document.getElementById('echarts_3');
                var myChart = echarts.init(chartDom);
                // 数据准备完毕之后再set
                myChart.setOption(this.category_option);
            })

        },
        getAllPower() {

            this.category_option2 = {

                tooltip: {
                    trigger: 'item'
                },

                series: [
                    {
                        name: '项目耗能',
                        type: 'pie',
                        radius: '70%',
                        data: [
                            {value: 0, name: '总耗能'},
                            {value: 0, name: '当月耗能'},
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgb(86,239,247)'
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: function (colors) {
                                    var colorList = [
                                        'rgba(10,203,188,0.48)',
                                        '#5470c6',
                                        '#91cd77',
                                        '#ef6567',
                                        '#f9c956',
                                        '#75bedc'
                                    ];
                                    return colorList[colors.dataIndex];
                                }
                            },
                        },
                        label: {            //饼图图形上的文本标签
                            normal: {
                                show: true,
                                position: 'outer', //标签的位置
                                textStyle: {
                                    fontWeight: 300,
                                    fontSize: 14,    //文字的字体大小
                                    color: "#fff"
                                },
                                formatter: '{b}:{c}'
                            }
                        },

                    }
                ]
            };


            this.request.get("/project/findProjectSumPowerById/" + this.current_project.id, {}).then(res => {

                //let data = JSON.parse(res.data)
                console.log("总耗能",res.data)
                this.category_option2.series[0].data[0].value = res.data.power
                this.category_option2.series[0].data[1].value = res.data.month_power

                var chartDom = document.getElementById('echarts_4');
                var myChart = echarts.init(chartDom);
                // 数据准备完毕之后再set
                myChart.setOption(this.category_option2);
            })



        },
        row_handle(row, event, column) {
            console.log(row)

            this.request.get("/project/readWarn", {
                params: {
                    id: row.no,
                    time: row.time
                }
            }).then(res => {
                console.log(res)
                this.getWarn()
            })

            this.request.get("/devices/" + row.no, {}).then(res => {
                console.log(res)
                let data = res.data
                if (this.map != null) {
                    this.map.clearMap()
                }
                this.marker = new AMap.Marker({
                    map: this.map,
                    position: [data.device.lng, data.device.lat],

                });

                this.marker.setLabel({
                    direction: 'bottom',
                    offset: new AMap.Pixel(0, 0),  //设置文本标注偏移量
                    content: "<div class='info'>"+row.mes+"</div>", //设置文本标注内容

                });
                this.map.setCenter([data.device.lng, data.device.lat])
                this.map.setZoom(18)
            })
        },
        getdate(value) {
            var now = new Date(value.time * 1000),
                y = now.getFullYear(),
                m = now.getMonth() + 1,
                d = now.getDate();
            return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
        },
        tick() {
            let today;
            today = new Date();
            this.localtime = this.showLocale(today)
            //document.getElementById("localtime").innerHTML = showLocale(today);
            window.setTimeout(this.tick, 1000);
        },
        showLocale(objD) {
            var str, colorhead, colorfoot;
            var yy = objD.getYear();
            if (yy < 1900) yy = yy + 1900;
            var MM = objD.getMonth() + 1;
            if (MM < 10) MM = '0' + MM;
            var dd = objD.getDate();
            if (dd < 10) dd = '0' + dd;
            var hh = objD.getHours();
            if (hh < 10) hh = '0' + hh;
            var mm = objD.getMinutes();
            if (mm < 10) mm = '0' + mm;
            var ss = objD.getSeconds();
            if (ss < 10) ss = '0' + ss;
            var ww = objD.getDay();
            if (ww == 0) colorhead = "";
            if (ww > 0 && ww < 6) colorhead = "";
            if (ww == 6) colorhead = "";
            if (ww == 0) ww = "星期日";
            if (ww == 1) ww = "星期一";
            if (ww == 2) ww = "星期二";
            if (ww == 3) ww = "星期三";
            if (ww == 4) ww = "星期四";
            if (ww == 5) ww = "星期五";
            if (ww == 6) ww = "星期六";
            colorfoot = ""
            str = colorhead + yy + "-" + MM + "-" + dd + " " + hh + ":" + mm + ":" + ss + "  " + ww + colorfoot;
            return (str);
        }
    }

}
</script>

<style scoped>
@import "../style/css/common.css";
@import "../style/css/map.css";
/*@import "../style/amap.css";*/
html, body {

    width: 100%;

}

.frame {
    width: 100%;
    height: calc(100vh - 100px);
    border: none;
    display: block;

}

.el-table,
.el-table__expanded-cell {
    background-color: transparent !important;
}

/* 表格内背景颜色 */

.el-table th,
.el-table tr,
.el-table td {
    background-color: transparent !important;
    border: 0;
}

/*最外层透明*/
/deep/ .el-table, /deep/ .el-table__expanded-cell {
    background-color: transparent;
}

/* 表格内背景颜色 */
/deep/ .el-table th,
/deep/ .el-table tr,
/deep/ .el-table td {
    background-color: transparent;
}

/* # background-color为悬停行得背景颜色 ,color为悬停行得字体颜色，其他样式自行添加 */
/deep/ .el-table tbody tr:hover > td {
    background-color: transparent !important;;
    color: #42b983;
    cursor: pointer;
}
.info{
    position: relative;
    top: 0;
    right: 0;
    min-width: 0;
    border: 0;
    padding: 10px;
}

</style>
